<template>
  <el-menu class="navbar"
           mode="horizontal">
    <hamburger class="hamburger-container"
               :toggleClick="toggleSideBar"
               :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown @command="handleCommand"
                 class="avatar-container"
                 trigger="click">
      <div v-if="shopData.icon"
           class="avatar-wrapper">
        <img class="user-avatar"
             :src="shopData.icon">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <div v-else
           class="avatar-wrapper">
        <img class="user-avatar"
             src="../../../assets/images/default.png">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown"
                        slot="dropdown">
        <el-dropdown-item command="PersonalInfo">
          编辑个人资料
        </el-dropdown-item>
        <el-dropdown-item command="ChangeTel">
          更换绑定手机号码
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout"
                style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 弹窗 -->
    <PersonalInfo ref="detailModal"></PersonalInfo>
    <ChangeTel ref="changeModal"></ChangeTel>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import PersonalInfo from '@/views/sys/PersonalInfo'
import ChangeTel from '@/views/sys/ChangeTel'
import { homeData } from '@/api/home'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    PersonalInfo,
    ChangeTel
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data () {
    return {
      shopData: {},
    }
  },
  created () {
    this.getData()
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('ToggleSideBar')
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    handleCommand (command) {
      if (command === 'PersonalInfo') {
        this.$refs.detailModal.detail()
      } else if (command === 'ChangeTel') {
        this.$refs.changeModal.detail()
      }
    },
    getData () {
      homeData({}).then(res => {
        this.shopData = res.data.umsMchtInfoResult
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue